'use strict';
var $ = require('../internals/export');
var exec = require('../internals/regexp-exec');

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.regexp.exec.js
// module id = 188
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33